<template>
  <div>
    <div class="uk-section">
      <div class="uk-container uk-container-large">
        <h2 class="timeline-page__title">
          {{ $t(`message['Timeline of Recent Anti-Asian Incidents']`) }}
        </h2>
      </div>
      <div class="timeline-container">
        <iframe
          src="https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=19T6CrCT3sSli19KdJDourdplXBBG9wNyc5z3YJJ-Z9o&font=Default&lang=en&start_at_end=true&initial_zoom=5"
          width="100%"
          height="100%"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
// const timeline_json = {
//   start_at_end: true,
// };

export default {
  name: "TimelinePage",
  // mounted() {
  //   new window.TL.Timeline(
  //     "timeline-embed",
  //     "https://docs.google.com/spreadsheets/d/19T6CrCT3sSli19KdJDourdplXBBG9wNyc5z3YJJ-Z9o/edit#gid=0",
  //     timeline_json
  //   );
  // },
};
</script>
<style>
.timeline-container {
  height: 75vh;
  border: 3px solid blue;
}

.timeline-inner-container {
  display: flex;
}

.timeline-page__title {
  font-size: 50px;
  text-transform: uppercase;
  font-weight: bold;
  color: black;
}

@media only screen and (max-width: 700px) {
  .timeline-page__title {
    font-size: 30px;
  }
}
</style>
